var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-8",attrs:{"outlined":""}},[_c('v-card-text',[_c(_vm.component,{ref:"restaurantStep",tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }